import React, { useContext } from 'react'
import { RevUserContext, RevUserContextType } from '../../context/UserContext';
import { useReduxDispatch, useReduxSelector } from '../../redux/hooks';
import { cancelMimic } from '../../slices/RevelationSlice';

export const MimicBar = () => {
    const { profile } = React.useContext<RevUserContextType>(RevUserContext)
    const mimicUid = useReduxSelector((state) => state.revI.mimicUid);
    const dispatch = useReduxDispatch();
    const cancelMimicSession = () => {
        dispatch(cancelMimic());
    };
    if (!mimicUid)
        return <></>

    return (
        <>
            <div className='mimic-bar'>You are currently mimicing user account&nbsp;<u>{profile.F_Name} {profile.L_Name}</u>. Press X to cancel this mimic session.
                <button className="k-font-icon k-i-close" title='Cancel mimic session' onClick={cancelMimicSession}>
                </button></div></>
    )
}
